export default __webpack_public_path__ + "static/media/nemesysco_v2.0d671d9b.jpg";